import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormConfig from '../../Config/FormConfig';
import dayjs from 'dayjs';
import { Formik } from 'formik';
import { Table, Input, Row, Col, Button, DatePicker, Checkbox, Upload, Spin, message, InputNumber, Flex, Modal } from 'antd';
import { LoadingOutlined, InboxOutlined } from '@ant-design/icons';
import './NewManufacturerContractCss.css';
import APIService from '../../Service/APIService';
import CustomHeader from '../CustomHeader/CustomHeader';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider.js';
import { hasPermission } from '../../Config/permissions.js';
import { canAccessManufacturerCommissionContract } from './manufacturerContractAccess.js';

const components = {
  header: {
    cell: ({ style, ...restProps }) => (
      <th
        {...restProps}
        style={{
          ...style,
          backgroundColor: '#ffffff',
          color: '#000',
          borderColor: '#ffffff',
          paddingBottom: '2px',
          fontWeight: 500,
          marginTop: '8px',
        }}
      />
    ),
  },
  body: {
    cell: ({ style, ...restProps }) => (
      <td
        {...restProps}
        style={{
          ...style,
          backgroundColor: '#ffffff',
          color: '#000',
          borderColor: '#ffffff',
          paddingTop: '0px',
        }}
      />
    ),
  },
};

const NewManufacturerContract = () => {
  const { user, isReady } = useAuth();
  const userData = user;
  const navigate = useNavigate();
  const { id } = useParams();
  const [isEditable, setIsEditable] = useState(true);
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [uploadContract, setUploadContract] = useState(null);
  const [productGroups, setProductGroups] = useState([]);
  const [uploadContractFileList, setUploadContractFileList] = useState([]);
  const [uploadContractFilename, setUploadContractFilename] = useState(null);
  const [existingManufacturerContract, setExistingManufacturerContract] = useState(null);
  const [allCommissionContracts, setAllCommissionContracts] = useState([]);
  const [showStandardModal, setShowStandardModal] = useState(true);
  const [isNonStandardContract, setIsNonStandardContract] = useState(false);
  const manufacturerSelectionRequestRef = useRef(0);

  const generateFieldsArray = (data = null) => {
    const fields = FormConfig.NewManufacturerContract;
    // console.log(accountFields);
    // setFieldsArr(fields);
    const val = generateInitialValues(fields, data);
    console.log("Createedby ", val["CreatedBy"]);
    val["CreatedBy"] = (id !== null && id !== undefined) ? val["CreatedBy"] : userData.FirstName + " " + userData.LastName;
    val["CreatedByEmail"] = userData?.Email;

    // if (location.state && location.state.type === "Duplicate") {
    //   // add one day to end date and save in start date
    //   val["StartDate"] = dayjs(val["EndDate"]).add(1, 'days').startOf('day');
    //   val["EndDate"] = null;
    //   val["IsEnded"] = false;
    // }
    // else{
    val["StartDate"] = val["StartDate"] === null ? null : dayjs(val["StartDate"]);
    val["EndDate"] = val["EndDate"] === null ? null : dayjs(val["EndDate"]);
    val["IsEnded"] = val["IsEnded"] === null ? false : val["IsEnded"];
    // }
    console.log('Initial Values:', val);
    console.log("Createedby ", val["CreatedBy"]);
    setInitialValues(val);
    return val;
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] = cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    return obj;
  }

  const getManufacturerOptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend('getmanufactureroptions');
    // console.log("Distributors: ", response);
    let tempOptions = [];
    response?.data?.data.map((ele) => {
      tempOptions.push({
        value: ele.ID,
        label: ele.ManufacturerName
      });
    });
    setManufacturerOptions(tempOptions);
    return tempOptions;
  }

  const getContractData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getmanufacturercontractbyid?ID=${id}`);
    console.log("ManufacturerContract: ", response);
    setExistingManufacturerContract(response?.data?.data?.ManufacturerContract);
    const tempProducts = response?.data?.data?.ManufacturerCommissionContractProducts;
    if (tempProducts && tempProducts.length > 0) {
      const newData = mapProductGroups(tempProducts);
      setProductGroups(newData);
    } else {
      setProductGroups([]);
    }
    if (response?.data?.data?.ManufacturerContract?.UploadContract) {
      const filename = response?.data?.data?.ManufacturerContract?.UploadContractFilename ? response?.data?.data?.ManufacturerContract?.UploadContractFilename : "uploadcontract.pdf";
      setUploadContractFileList([{ name: filename, status: 'done', uid: '1' }]);
      // setUploadContract(blob);
      setUploadContractFileBlobName(response?.data?.data?.ManufacturerContract?.AzureBlobName);
      setUploadContractFilename(filename);
    }

    generateFieldsArray(response?.data?.data?.ManufacturerContract);
    setIsEditable(false);
    return response?.data?.data?.ManufacturerContract;
  }

  const mapProductGroups = (groups = [], manufacturerName = null) => {
    if (!Array.isArray(groups)) {
      return [];
    }

    return groups.map((item, index) => ({
      ...item,
      key: item?.ID ?? item?.ProductGroupID ?? item?.GroupID ?? index + 1,
      ManufacturerName: item?.ManufacturerName ?? manufacturerName ?? '',
      ManufacturerCommissionPercentage:
        (item.ManufacturerCommissionPercentage === null ||
          item.ManufacturerCommissionPercentage === undefined)
          ? 0
          : item.ManufacturerCommissionPercentage,
    }));
  };

  const getProductGroups = async (manufacturerID, manufacturerName = null) => {
    if (!manufacturerID) {
      return [];
    }

    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getallproductgroupsbymanid?ManID=${manufacturerID}`
    );
    const newData = mapProductGroups(response?.data?.data, manufacturerName);
    console.log("Product Groups: ", newData);
    return newData;
  }

  const [uploadContractFileBlobName, setUploadContractFileBlobName] = useState(null);

  useEffect(() => {
    if (!isReady || !userData) return;

    // Your code here
    console.log("NewManufacturerContract.js", id);
    if (!canAccessManufacturerCommissionContract(userData, id)) {
      if (userData.Type === "Account") {
        navigate(`/Account/${userData.AccountID}`);
      } else if (userData.Type === "Distributor") {
        navigate(`/Distributor/${userData.DistributorID}`);
      } else {
        navigate("/");
      }
      return;
    }

    // generateFieldsArray();
    if (id) {
      setShowStandardModal(false);
      getManufacturerOptions();
      getContractData().then(() => {
        setLoading(false);
      });
    }
    else {
      generateFieldsArray(null);
      setIsEditable(true);
      getManufacturerOptions();
      setProductGroups([]);
      setAllCommissionContracts([]);
      setLoading(false);
    }
  }, [id, isReady, userData]);


  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadContractFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }


    // download the file from Azure Blob Storage
    const link = document.createElement('a');
    link.href = sasUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // const link = document.createElement("a");
    // let url = null;
    // console.log("Uploaded Contract: ", uploadContract);
    // url = window.URL.createObjectURL(uploadContract);
    // link.href = url;
    // link.setAttribute("download", uploadContractFilename); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: ['.pdf'],
    // customRequest:  handleFile,
    disabled: !isEditable,
    onChange(info) {
      const { status } = info.file;
      // set limit of 4mb on file size and throw error
      // if (info.file.size > 4194304) {
      //   message.error(`${info.file.name} is too large, please select a file less than 4MB`);
      //   return;
      // }
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const handleFile = async ({ file, onSuccess }) => {
    // setIvrReport(file);
    if (file.size > 4194304) {
      message.error(`${file.name} is too large, please select a file less than 4MB`);
      return;
    }
    setUploadContract(file);
    setUploadContractFilename(file.name);
    setUploadContractFileList([{ name: file.name, status: 'done', uid: '1' }]);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }

  const getManufacturerCommissionOptions = async (manID) => {
    if (!manID) {
      return [];
    }

    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`manufacturercommissionoptions?ManufacturerID=${manID}`);
    console.log("Manufacturere Commission Options: ", response);
    const existingContracts = response?.data?.data?.ExistingManufacturerContracts ?? [];
    return existingContracts;
  }

  const loadManufacturerDependencies = async (manufacturerID, manufacturerName = null) => {
    const requestId = ++manufacturerSelectionRequestRef.current;

    if (!manufacturerID) {
      setAllCommissionContracts([]);
      setProductGroups([]);
      return;
    }

    const [existingContracts, groups] = await Promise.all([
      getManufacturerCommissionOptions(manufacturerID),
      getProductGroups(manufacturerID, manufacturerName),
    ]);

    if (manufacturerSelectionRequestRef.current !== requestId) {
      return;
    }

    setAllCommissionContracts(existingContracts ?? []);
    setProductGroups(groups ?? []);
  }

  const handleButtonClick = (submitForm) => {
    if (isEditable) {
      submitForm(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  const submitHandler = async (values) => {
    console.log("Values: ", values);
    values.UploadContractFilename = uploadContractFilename;
    // return;
    setLoading(true);
    // start date should be less than end date
    if (values.StartDate && values.EndDate) {
      if (values.StartDate.isAfter(values.EndDate)) {
        setLoading(false);
        message.error("Start date should be less than end date");
        return;
      }
    }

    if (values.IsEnded && values.EndDate === null) {
      setLoading(false);
      message.error("Please select end date");
      return;
    }

    // check if dates are overlapping with allcontracts start and end dates
    if (id === null || id === undefined) {
      const startDate = values.StartDate;
      const endDate = values.EndDate;
      console.log("allCommissionContracts: ", allCommissionContracts);
      if (startDate && endDate && allCommissionContracts.length > 0) {
        const check = allCommissionContracts.some((item) => {
          const contractStartDate = dayjs(item.StartDate);
          const contractEndDate = dayjs(item.EndDate);
          if (startDate.isAfter(contractStartDate) && startDate.isBefore(contractEndDate)) {
            message.error("Contract dates are overlapping with existing contracts");
            return true;
          }
          else if (endDate.isAfter(contractStartDate) && endDate.isBefore(contractEndDate)) {
            message.error("Contract dates are overlapping with existing contracts");
            return true;
          }
          return false;
        });
        if (check) {
          setLoading(false);
          return;
        }
      }
    }

    // return;
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        values.IsNonStandard = isNonStandardContract;
        const postObj = {
          ManufacturerCommissionContract: values,
          ProductGroups: productGroups,
        };
        const apiServe = new APIService();
        let formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("files", uploadContract);
        console.log("FormData: ", formData);
        let url = null;
        if (id !== null && id !== undefined) {
          url = `updatemanufacturercontract?ID=${id}`;
        }
        else {
          url = `createmanufacturercontract`;
        }
        console.log("URL: ", url);
        const response = await apiServe.addFileDataToBackend(formData, url, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log("Response: ", response);
        if (response?.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: response?.data?.message,
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            window.location.href = '/Manufacturer/' + values.ManufacturerID;
          });
        }
        else {
          Swal.fire({
            title: 'Error!',
            text: response?.data?.message,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      }
      else {
        setLoading(false);
      }
    });
  }

  const updateProductGroupField = (key, column, value) => {
    const newData = productGroups.map((row) =>
      row.key === key ? { ...row, [column]: value } : row
    );
    setProductGroups(newData);
  };

  const handleInputChange = (value, key, column) => {
    if (column === "ManufacturerCommissionPercentage") {
      // allow only numbers between 0 and 100
      if (value < 0 || value > 100) {
        message.error("Commission Percentage should be between 0 and 100");
        return;
      }
      // allow only numbers
      if (isNaN(value)) {
        message.error("Commission Percentage should be a number");
        return;
      }
      // allow only 2 decimal places
      if (value.toString().split(".").length > 2) {
        message.error("Commission Percentage should be a number");
        return;
      }
      if (value.toString().split(".")[1]?.length > 2) {
        message.error("Commission Percentage should be a number");
        return;
      }
    }

    updateProductGroupField(key, column, value);
  };

  const columns = [
    {
      title: 'Manufacturer',
      dataIndex: 'ManufacturerName',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.ManufacturerName ?? ''}
          disabled={true}
        />
      ),
    },
    {
      title: 'Product',
      dataIndex: 'ProductGroupName',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.ProductGroupName ?? ''}
          disabled={true}
        />
      ),
    },
    {
      title: 'Commission %',
      dataIndex: 'ManufacturerCommissionPercentage',
      width: '15%',
      render: (_, record) => (
        <InputNumber
          min={0}
          max={100}
          style={{ width: '100%' }}
          value={record.ManufacturerCommissionPercentage}
          onChange={(value) =>
            handleInputChange(value ?? 0, record.key, 'ManufacturerCommissionPercentage')
          }
          disabled={!isEditable}
        />
      ),
    },
    {
      title: 'Is Tiered',
      dataIndex: 'IsTiered',
      width: '15%',
      render: (_, record) => (
        <Checkbox
          checked={Boolean(record.IsTiered)}
          disabled={!isEditable}
          onChange={e => {
            updateProductGroupField(record.key, 'IsTiered', e.target.checked);
          }}
        />
      ),
    },
    {
      title: 'Tier Two Commission Percentage',
      dataIndex: 'TierTwoCommissionPercentage',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.TierTwoCommissionPercentage ?? ''}
          style={{ width: '100%' }}
          onChange={e =>
            handleInputChange(e.target.value, record.key, 'TierTwoCommissionPercentage')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
    {
      title: 'Tier Three Commission Percentage',
      dataIndex: 'TierThreeCommissionPercentage',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.TierThreeCommissionPercentage ?? ''}
          style={{ width: '100%' }}
          onChange={e =>
            handleInputChange(e.target.value, record.key, 'TierThreeCommissionPercentage')
          }
          disabled={isEditable === true ? (!record.IsTiered) : true}
        />
      ),
    },
  ];

  const handleDeleteContract = async () => {
      console.log("delete contract");
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const apiServe = new APIService();
          const response = await apiServe.addDataToBackend({ ContractID: id }, "deletemanufacturercontractbyid");
          console.log("Response: ", response);
          if (response?.status === 200) {
            Swal.fire({
              title: 'Deleted!',
              text: "Manufacturer Contract has been deleted.",
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              window.location.href = '/Manufacturer/' + existingManufacturerContract.DistributorID;
            });
          }
          else {
            setLoading(false);
            Swal.fire({
              title: 'Error!',
              text: response?.data?.message,
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        }
      });
    }

  return (
    <div>
      {!id && showStandardModal && !loading &&
        // <div style={{ padding: '24px', background: '#fff', minHeight: '360px' }}>
        <Modal
          title="Choose Contract Type"
          open={showStandardModal}
          // onOk={handleOk}
          centered={true}
          footer={false}
        >
          <Row gutter={16} style={{ marginBottom: '20px' }}>
            <Col span={12} style={{ marginBottom: '10px' }}>
              <Button
                type="primary"
                onClick={() => {
                  setIsNonStandardContract(false);
                  setShowStandardModal(false);
                }}
                style={{ background: "#27a907" }}
              >
                Standard Contract
              </Button>
            </Col>
            <Col span={12} style={{ marginBottom: '10px' }}>
              <Button
                type="primary"
                onClick={() => {
                  setIsNonStandardContract(true);
                  setShowStandardModal(false);
                }}
                style={{ background: "#27a907" }}
              >
                Non-Standard Contract
              </Button>
            </Col>
          </Row>
        </Modal>
        // </div>
      }
      {!showStandardModal && initialValues &&
        <CustomHeader leftTopText="Welcome back!"
          leftBottomText={id !== null && id !== undefined ? "Manufacturer Commission Contract" : "New Commission Contract"}
          rightTopText="Logged in as Admin"
          rightBottomText="User"
        />
      }
      {loading &&
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      }
      {!showStandardModal && initialValues && (
        <Formik onSubmit={submitHandler} initialValues={initialValues} >
          {(formik) => (
            // console.log("formik: ", formik),
            <form onSubmit={formik.handleSubmit}>
              {id !== null && id !== undefined &&
                <div>
                  {(hasPermission(userData, "mfr_contract.edit") ||
                    hasPermission(userData, "mfr_contract.delete")) &&
                    <div style={{ display: 'flex', gap: '16px', margin: '30px 0px 30px 0px' }}>
                      {hasPermission(userData, "mfr_contract.edit") &&
                        <Button
                          type="primary"
                          style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
                          onClick={() => handleButtonClick(formik.handleSubmit)}
                        >
                          {isEditable ? 'Save Changes' : 'Edit'}
                        </Button>
                      }
                      {id && hasPermission(userData, "mfr_contract.delete") &&
                        <Button
                          type="primary"
                          style={{ marginBottom: 16, background: 'red' }}
                          onClick={handleDeleteContract}
                        >
                          Delete
                        </Button>
                      }
                    </div>
                  }
                </div>
              }
              <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', marginBottom: '30px' }}>
                <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Contract Details</p>
              </div>
              <Row gutter={16}>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Manufacturer Name <span style={{ color: 'red' }}>*</span></label>
                  <Select
                    onBlur={() => formik.setFieldTouched("ManufacturerID")}
                    // title={formik.values["AccountID"]}
                    value={formik.values["ManufacturerID"] ? { label: formik.values["ManufacturerName"], value: formik.values["ManufacturerID"] } : null}
                    // onChange={async (value, option) => {
                    onChange={async (selectedOption) => {
                      if (!selectedOption) {
                        manufacturerSelectionRequestRef.current += 1;
                        formik.setFieldValue("ManufacturerName", null);
                        formik.setFieldValue("ManufacturerID", null);
                        formik.setFieldValue("StartDate", null);
                        formik.setFieldValue("EndDate", null);
                        formik.setFieldValue("IsEnded", false);
                        setProductGroups([]);
                        setAllCommissionContracts([]);
                        return;
                      }

                      console.log("Value: ", selectedOption.value);
                      console.log("Option: ", selectedOption);
                      formik.setFieldValue("ManufacturerName", selectedOption.label);
                      formik.setFieldValue("ManufacturerID", selectedOption.value);
                      formik.setFieldValue("StartDate", null);
                      formik.setFieldValue("EndDate", null);
                      formik.setFieldValue("IsEnded", false);
                      await loadManufacturerDependencies(selectedOption.value, selectedOption.label);
                    }}
                    style={{ width: '100%' }}
                    defaultValue=""
                    options={manufacturerOptions}
                    isClearable={!id}
                    isDisabled={!isEditable || Boolean(id)}
                  />
                </Col>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Start Date<span style={{ color: 'red' }}>*</span></label>
                  <DatePicker
                    format="MM-DD-YYYY"
                    onBlur={() => formik.setFieldTouched("StartDate")}
                    title={formik.values["StartDate"]}
                    value={formik.values["StartDate"]}
                    onChange={(date, dateString) =>
                      formik.setFieldValue(
                        "StartDate",
                        date
                      )
                    }
                    style={{ width: '100%' }}
                    // disabledDate={(currentDate) => 
                    //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                    // }
                    disabledDate={(currentDate) => {
                      const lastEndDate = allCommissionContracts?.reduce((latest, contract) => {
                        const contractEndDate = dayjs(contract?.EndDate);
                        return contractEndDate?.isAfter(latest) ? contractEndDate : latest;
                      }, dayjs(0)); // Initialize with the earliest possible date
                      return currentDate && (currentDate < lastEndDate?.add(1, 'days').startOf('day'));
                    }}
                    disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                  />
                </Col>
                <Col span={2} style={{ width: '100%' }}>
                  <label className="form-label">Has End Date <span style={{ color: 'red' }}>*</span></label>
                  <Checkbox
                    name="IsEnded"
                    checked={formik.values.IsEnded}
                    onChange={(e) => {
                      formik.setFieldValue("IsEnded", e.target.checked);
                      if (e.target.checked) {
                        formik.setFieldValue("EndDate", dayjs());
                      }
                    }}
                    disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                  />
                </Col>
                {formik.values.IsEnded &&
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">End Date<span style={{ color: 'red' }}>*</span></label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("EndDate")}
                      title={formik.values["EndDate"]}
                      value={formik.values["EndDate"]}
                      onChange={(date, dateString) =>
                        formik.setFieldValue(
                          "EndDate",
                          date
                        )
                      }
                      style={{ width: '100%' }}
                      // disabledDate={(currentDate) => 
                      //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                      // }
                      disabled={!isEditable}
                    />
                  </Col>
                }
                <Col span={4} style={{ width: '100%' }}>
                  <label className="form-label">Created By</label>
                  <Input
                    name="CreatedBy"
                    value={formik.values["CreatedBy"]}
                    defaultValue={formik.values["CreatedBy"]}
                    disabled
                  />
                </Col>
                {isNonStandardContract === false &&
                  <Col span={4} style={{ width: '100%' }}>
                    <label className="form-label">Tier 1 Manufacturer Commission %</label>
                    <Input
                      name="TierOnePercentage"
                      value={formik.values["TierOnePercentage"]}
                      defaultValue={formik.values["TierOnePercentage"]}
                      onBlur={() => formik.setFieldTouched("TierOnePercentage")}
                      onChange={formik.handleChange}
                      disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                    />
                  </Col>
                }
              </Row>
              {isNonStandardContract === false &&
                <Row gutter={16}>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Tier 2 Start</label>
                    <Input
                      name="TierTwoStart"
                      value={formik.values["TierTwoStart"]}
                      defaultValue={formik.values["TierTwoStart"]}
                      onBlur={() => formik.setFieldTouched("TierTwoStart")}
                      onChange={formik.handleChange}
                      disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Tier 2 Manufacturer Commission %</label>
                    <Input
                      name="TierTwoPercentage"
                      value={formik.values["TierTwoPercentage"]}
                      defaultValue={formik.values["TierTwoPercentage"]}
                      onBlur={() => formik.setFieldTouched("TierTwoPercentage")}
                      onChange={formik.handleChange}
                      disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Tier 3 Start</label>
                    <Input
                      name="TierThreeStart"
                      value={formik.values["TierThreeStart"]}
                      defaultValue={formik.values["TierThreeStart"]}
                      onBlur={() => formik.setFieldTouched("TierThreeStart")}
                      onChange={formik.handleChange}
                      disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                    />
                  </Col>
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">Tier 3 Manufacturer Commission %</label>
                    <Input
                      name="TierThreePercentage"
                      value={formik.values["TierThreePercentage"]}
                      defaultValue={formik.values["TierThreePercentage"]}
                      onBlur={() => formik.setFieldTouched("TierThreePercentage")}
                      onChange={formik.handleChange}
                      disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                    />
                  </Col>
                </Row>
              }
              <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col span={24} style={{ width: '100%' }}>
                  <label className="form-label">Upload Contract</label>
                  <Upload.Dragger
                    {...uploadProps}
                    customRequest={({ file, onSuccess }) => handleFile({ file, onSuccess }, "UploadContract")}
                    onPreview={() => downloadFile("UploadContract")}
                    fileList={uploadContractFileList}
                    onRemove={() => {
                      setUploadContract(null);
                      setUploadContractFileList([]);
                      setUploadContractFilename(null);
                    }}
                    disabled={formik.values.ManufacturerID !== null ? !isEditable : true}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Drag or click to upload file</p>
                    <p className="ant-upload-hint">
                      Accepted format: PDF (Max file size limit: 4MB)
                    </p>
                  </Upload.Dragger>
                </Col>
              </Row>
              {isNonStandardContract === false &&
                <>
                  <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', margin: '80px 0px 20px 0px' }}>
                    <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Product Commission %</p>
                  </div>
                  <Table
                    columns={columns}
                    dataSource={productGroups}
                    pagination={false}
                    components={components}
                    rowKey="key"
                    bordered={false}
                  />
                </>
              }
              <div style={{ display: 'flex', justifyContent: 'end', padding: '0px 8px', margin: '80px 0px 20px 0px' }}>
                <Button onClick={formik.handleSubmit} type='primary' style={{ background: '#27a907', fontSize: '14px', fontWeight: '600' }}>Save Contract</Button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
}
export default NewManufacturerContract;
